
import {getQryResponseByRequestId} from '../apiCalls';

export const getRecentQry = (brokerId, page = 1) => {
    return {
        type: 'GET_RECENT_QRY',
        brokerId,
        page
    }
}

export const setRecentQry = (response) => {
    return {
        type: 'SET_RECENT_QRY',
        recentQryList: response.data.eventMessage.searchResults
    }
}

export const recentQryClicked = (requestId, action, qryType) => {
    window.qryTimeout = true;
    getQryResponseByRequestId(requestId, action, qryType, 18);
}

export const setPage = (page) => {
    return {
      type: "SET_PAGE",
      page
    }
}

export const updatePage = (page) => {
    return (dispatch, getState) => {
      dispatch(setPage(page))
      return dispatch(getRecentQry(window.brokerId, page))
    }
}
